export default "__VITE_ASSET__Di1yGUvj__"